module.exports = {
  LIVE: 'live',
  UPCOMING: 'upcoming',
  PREVIEW: 'preview',
  CLOSED: 'closed',
};
